import React from 'react'


import Pricing from '../Components/Pricing/Pricing'

import Hero2 from '../Components/Header/Hero2'
import Testimonial from '../Components/Testimonial/Testimonial'
import HowToResubscribe from '../Components/HowToResubscribe/HowToResubscribe'


const EndSubscription = () => {
    return (
        <>
            <Hero2 />
            <HowToResubscribe />
            <div id="pricing">
                <Pricing />
            </div>
            <div id="testimonial">
                <Testimonial />
            </div>
        </>
    )
}

export default EndSubscription